import { IoCheckmarkSharp } from 'react-icons/io5';
import { DropdownOption } from 'src/types/dropdown.types';
import Text from '../text/Text';
import styles from './Dropdown.module.css';
import Button from '../button/Button';
import { useState } from 'react';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';

type DropdownPopUpContentProps = {
  options: DropdownOption[];
  value: DropdownOption | null;
  onChange: (option: DropdownOption) => void;
};

const DropdownPopUpContent = ({
  options,
  value,
  onChange,
}: DropdownPopUpContentProps) => {
  const { dispatch } = useAppContext();
  const [selectedOption, setSelectedOption] = useState<DropdownOption | null>(
    value
  );
  const handleSelectOption = (value: DropdownOption) => {
    setSelectedOption(value);
  };
  const handlePopUpClose = () => {
    onChange(selectedOption as DropdownOption);
    dispatch({ type: ActionType.POP_UP_CLOSE, payload: {} });
  };
  return (
    <>
      {options.map((option: DropdownOption) => (
        <div
          className={styles['dropdown-option']}
          key={option.key}
          onClick={() => handleSelectOption(option)}
        >
          <Text
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontWeight:
                selectedOption?.value === option.value ? 'bold' : 'normal',
            }}
          >
            <span>{option.value}</span>
            {selectedOption?.value === option.value && <IoCheckmarkSharp />}
          </Text>
        </div>
      ))}
      <Button
        type='primary'
        width='full-width'
        onClick={handlePopUpClose}
        isReadOnly={!selectedOption}
        style={{ marginTop: '32px', width: '100%', marginLeft: 0 }}
      >
        Continue
      </Button>
    </>
  );
};

export default DropdownPopUpContent;
